module.exports = "/assets/data/aa92a2cb9691b49cea8a8979b8ae30e5-SE23.data.json";